import { RootStore } from '../../../../common/js/stores/root.store';
import { reaction } from '../../../../common/js/utils/preact-utils';
import { DebugLog } from '../../../../common/js/debug-log';
import {
  sendCreativeHeaderMinimized,
  sendCreativeHeaderOptimized
} from '../../../../common/js/TrackAnalyticsHelper';
import { AdContainerStore } from '../../../../common/js/stores/ad-container.store';
import { isHeaderAdUnit } from '../../../../common/js/adUnit';
import { AdContainerState } from '../../../../common/domain/ad-container.domain';

export class HeaderAdResizeHandler {
  rootStore: RootStore;
  adContainerStore: AdContainerStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.adContainerStore = this.rootStore.adContainerStore;

    if (!this.isEnabled()) {
      return;
    }

    DebugLog.log('HeaderAdResizeHandler initializing observers');
    this.initObservers();
  }

  isEnabled(): boolean {
    return isHeaderAdUnit(this.rootStore.adContextStore.adContext.adUnitType);
  }

  initObservers(): void {
    reaction(
      () => this.adContainerStore.state.value,
      (state: AdContainerState) => {
        DebugLog.log('Video SDK3 header ad state reaction triggered', {
          state: state as string
        });
        if (state === 'resized') {
          DebugLog.log('Video SDK3 sending header_minimized tracking');
          sendCreativeHeaderMinimized();
        } else if (state === 'default') {
          DebugLog.log('Video SDK3 sending header_optimized tracking');
          sendCreativeHeaderOptimized();
        }
      }
    );
  }
}
